module.exports = __webpack_public_path__ + "static/media/exit.1bdde46b.svg";